import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AppHeader from '../components/AppHeader.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      header: AppHeader,
      default: HomeView,
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/login',
    name: 'Login',
    components: {
      header: AppHeader,
      default: () => import('../views/auth/LoginView.vue'),
    },
  },
  {
    path: '/article/create',
    name: 'create',
    components: {
      header: AppHeader,
      default: () => import('../views/article/CreateView.vue'),
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/article/:id',
    name: 'article',
    components: {
      header: AppHeader,
      default: () => import('../views/article/ArticleView.vue'),
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/results',
    name: 'results',
    components: {
      header: AppHeader,
      default: () => import('../views/ResultsView.vue'),
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/results/:id',
    name: 'result',
    components: {
      header: AppHeader,
      default: () => import('../views/ResultView.vue'),
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '*',
    name: 'pagenotfound',
    components: {
      header: AppHeader,
      default: () => import('../views/PageNotFoundView.vue'),
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
